import React, { useState } from "react";
import "../assets/css/styles.css";
import { NavLink,Link,useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);

  const toggleNav = () => {
    setIsNavOpen(!isNavOpen);
  };
  const location = useLocation();
  const isActive = location.pathname === '/';
  const isSubLinkActive = location.pathname.startsWith('/ashtotharalu') || 
                         location.pathname.startsWith('/slokalu') || 
                         location.pathname.startsWith('/shotramlu') || 
                         location.pathname.startsWith('/thidra-yatra') || 
                         location.pathname.startsWith('/athyadhimika-shakthi') || 
                         location.pathname.startsWith('/upavasam');
                         const isBhaktiActive = location.pathname.startsWith('/ashtotharalu') || 
                         location.pathname.startsWith('/slokalu') || 
                         location.pathname.startsWith('/shotramlu') || 
                         location.pathname.startsWith('/thidra-yatra') || 
                         location.pathname.startsWith('/athyadhimika-shakthi') || 
                         location.pathname.startsWith('/upavasam');
                           const isNakshatraActive = location.pathname.startsWith('/muhurthalu') || location.pathname.startsWith('/vivaha-nakshatralu');
                         const isHinduDharmActive = location.pathname.startsWith('/dharmasandehalu') || 
                         location.pathname.startsWith('/hindu-darmashastram') || 
                         location.pathname.startsWith('/pandugapramukyata') || 
                         location.pathname.startsWith('/masa-vishistatha') || 
                         location.pathname.startsWith('/srusti-rahasyalu') || 
                         location.pathname.startsWith('/jeevanashaili');
                         const isAstrologyActive = location.pathname.startsWith('/sankya-Shastram') || 
                          location.pathname.startsWith('/grahalu') || 
                          location.pathname.startsWith('/bhavishyavani') || 
                          location.pathname.startsWith('/vasthu-chitkalu');
                          const isValuableInfoActive = location.pathname.startsWith('/villuvina-samacharam') || 
                          location.pathname.startsWith('/nithya-sathyalu') || 
                          location.pathname.startsWith('/nithi-padhyalu') || 
                          location.pathname.startsWith('/samethalu') || 
                          location.pathname.startsWith('/samskrutham') || 
                          location.pathname.startsWith('/rastrala-bashalu') || 
                          location.pathname.startsWith('/grahanam');
                          const isOtherLinksActive = location.pathname.startsWith('/telugu-samskrutham') || 
                          location.pathname.startsWith('/telugu-panchangam') || 
                          location.pathname.startsWith('/sankya-pradanyata') || 
                          location.pathname.startsWith('/namakaranam') || 
                          location.pathname.startsWith('/balli-shastram');
                          const isMahabharatLinksActive = location.pathname.startsWith('/adhi-parvam') || 
                          location.pathname.startsWith('/sabha-parvam') || 
                          location.pathname.startsWith('/vana-parvam') || 
                          location.pathname.startsWith('/virata-parvam') || 
                          location.pathname.startsWith('/vudhyoga-parvam') || 
                          location.pathname.startsWith('/bhishma-parvam') || 
                          location.pathname.startsWith('/dhrona-parvam') || 
                          location.pathname.startsWith('/karna-parvam') || 
                          location.pathname.startsWith('/salya-parvam') || 
                          location.pathname.startsWith('/swothika-parvam') || 
                          location.pathname.startsWith('/sri-parvam') || 
                          location.pathname.startsWith('/santhi-parvam') || 
                          location.pathname.startsWith('/anusasanika-parvam') || 
                          location.pathname.startsWith('/aswamedha-parvam') || 
                          location.pathname.startsWith('/asramavasa-parvam') || 
                          location.pathname.startsWith('/mousala-parvam') || 
                          location.pathname.startsWith('/mahaprasthanika-parvam') || 
                          location.pathname.startsWith('/swargarohana-parvam');
                          const isBhagavadGitaActive =
                          location.pathname.startsWith('/bhagavathgita') ||
                          location.pathname.startsWith('/krishnani-jananam') ||
                          location.pathname.startsWith('/pandugala-visistatha') ||
                          location.pathname.startsWith('/geetha-saramsam') ||
                          location.pathname.startsWith('/pandugaluu') ||
                          location.pathname.startsWith('/sri-krishna-astrotharalu') ||
                          location.pathname.startsWith('/sri-krishnastakam') ||
                          location.pathname.startsWith('/bhakthi-sukthulu') ||
                          location.pathname.startsWith('/vasthavalu');
                        
  return (
    <div>
      <div className="container-fluid">
        <div className="row">
          <nav className="navbar navbar-expand-lg navbar-light bg-lightbrown">
            <button
              className="navbar-toggler m-3 bg-white"
              type="button"
              onClick={toggleNav}
              aria-label="Toggle navigation"
              style={{
                border: "2px solid rgba(0, 0, 0, 0.5)",
                outline: "none",
              }}
            >
              <span className="navbar-toggler-icon"></span>
            </button>

            <div
              className={`collapse navbar-collapse ${isNavOpen ? "show" : ""}`}
            >
              <ul className="navbar-nav ">
                <li className="nav-item maintic">
                  <NavLink
                    className="nav-link "
                    href="#"
                    id="navbarDropdownMenuLink4"
                    role="button"
                    onClick={toggleNav}
                    aria-haspopup="true"
                    aria-expanded="false"
                    activeClassName="active"
                  >
                    <NavLink to="/home" activeClassName="active">
                      హోం
                    </NavLink>
                  </NavLink>
                </li>
                <Link
                  to="/telugucalendarpanchangam"
                  style={{ position: "absolute", left: "-9999px" }}
                >
                  Telugu Panchangam SEO Page
                </Link>

                <li className="nav-item maintic">
                  <NavLink
                    className="nav-link "
                    href="#"
                    id="navbarDropdownMenuLink4"
                    role="button"
                    onClick={toggleNav}
                    aria-haspopup="true"
                    aria-expanded="false"
                    activeClassName="active"
                  >
                    <NavLink to="/panchangam" activeClassName="active">
                      పంచాంగం
                    </NavLink>
                  </NavLink>
                </li>
                <li className="nav-item maintic">
                  <NavLink
                    className="nav-link "
                    href="#"
                    id="navbarDropdownMenuLink4"
                    role="button"
                    onClick={toggleNav}
                    aria-haspopup="true"
                    aria-expanded="false"
                    activeClassName="active"
                  >
                    <NavLink to="/rasi-phalalu" activeClassName="active">
                      రాశి&nbsp;ఫలాలు
                    </NavLink>
                  </NavLink>
                </li>
                <li className="nav-item maintic">
                  <NavLink
                    className="nav-link "
                    href="#"
                    id="navbarDropdownMenuLink4"
                    role="button"
                    onClick={toggleNav}
                    aria-haspopup="true"
                    aria-expanded="false"
                    activeClassName="active"
                  >
                    <NavLink to="/pandugalu" activeClassName="active">
                      {" "}
                      పండుగలు
                    </NavLink>
                  </NavLink>
                </li>
                <li className="nav-item dropdown">
  <NavLink
    className={`nav-link dropdown-toggle ${isBhaktiActive ? 'active' : ''}`}
    href="#"
    id="navbarDropdownMenuLink4"
    role="button"
    onClick={toggleNav}
    aria-haspopup="true"
    aria-expanded="false"
    style={{
      color: isBhaktiActive ? 'white' : 'black', // Active state text color (white) / Default (black)
    }}
  >
    భక్తిరంజని
  </NavLink>
  <div className="dropdown-menu" aria-labelledby="navbarDropdownMenuLink4">
    <NavLink to="/ashtotharalu" className="dropdown-item" activeClassName="active">
      అష్టోత్తరాలు
    </NavLink>
    <NavLink to="/slokalu" className="dropdown-item" activeClassName="active">
      శ్లోకాలు
    </NavLink>
    <NavLink to="/shotramlu" className="dropdown-item" activeClassName="active">
      స్తోత్రములు
    </NavLink>
    <NavLink to="/thidra-yatra" className="dropdown-item" activeClassName="active">
      తీర్థ యాత్ర
    </NavLink>
    <NavLink to="/athyadhimika-shakthi" className="dropdown-item" activeClassName="active">
      ఆధ్యాత్మిక శక్తి
    </NavLink>
    <NavLink to="/upavasam" className="dropdown-item" activeClassName="active">
      ఉపవాసం
    </NavLink>
  </div>
</li>

<li className="nav-item dropdown">
  <NavLink
    className={`nav-link dropdown-toggle ${isNakshatraActive ? 'active' : ''}`}
    href="#"
    id="navbarDropdownMenuLink5"
    role="button"
    onClick={toggleNav}
    aria-haspopup="true"
    aria-expanded="false"
    style={{
      color: isNakshatraActive ? 'white' : 'black', // Active state text color (white) / Default (black)
    }}
  >
    నక్షత్ర పొంతన
  </NavLink>
  <div className="dropdown-menu" aria-labelledby="navbarDropdownMenuLink5">
    <NavLink to="/muhurthalu" className="dropdown-item" activeClassName="active">
      ముహూర్తాలు
    </NavLink>
    <NavLink to="/vivaha-nakshatralu" className="dropdown-item" activeClassName="active">
      వివాహ నక్షత్రాలు
    </NavLink>
  </div>
</li>

<li className="nav-item dropdown">
  <NavLink
    className={`nav-link dropdown-toggle ${isHinduDharmActive ? 'active' : ''}`}
    href="#"
    id="navbarDropdownMenuLink6"
    role="button"
    onClick={toggleNav}
    aria-haspopup="true"
    aria-expanded="false"
    style={{
      color: isHinduDharmActive ? 'white' : 'black', // Active state text color (white) / Default (black)
    }}
  >
    హిందూ ధర్మ వైభవం
  </NavLink>
  <div className="dropdown-menu" aria-labelledby="navbarDropdownMenuLink6">
    <NavLink to="/dharmasandehalu" className="dropdown-item" activeClassName="active">
      ధర్మసందేహాలు
    </NavLink>
    <NavLink to="/hindu-darmashastram" className="dropdown-item" activeClassName="active">
      హిందూ ధర్మశాస్త్రం
    </NavLink>
    <NavLink to="/pandugapramukyata" className="dropdown-item">
      పండుగ ప్రాముఖ్యత
    </NavLink>
    <NavLink to="/masa-vishistatha" className="dropdown-item" activeClassName="active">
      మాస విశిష్టత
    </NavLink>
    <NavLink to="/srusti-rahasyalu" className="dropdown-item" activeClassName="active">
      సృష్టి రహస్యాలు
    </NavLink>
    <NavLink to="/jeevanashaili" className="dropdown-item" activeClassName="active">
      జీవనశైలి
    </NavLink>
  </div>
</li>

                <li className="nav-item dropdown">
                <NavLink
  className={`nav-link dropdown-toggle ${isAstrologyActive ? 'active' : ''}`}
  href="#"
  id="navbarDropdownMenuLink7"
  role="button"
  onClick={toggleNav}
  aria-haspopup="true"
  aria-expanded="false"
  style={{
    color: isAstrologyActive ? 'white' : 'black', // Active state text color (white) / Default (black)
  }}
>
  ఆస్ట్రాలజీ
</NavLink>

                  <div
                    className="dropdown-menu"
                    aria-labelledby="navbarDropdownMenuLink7"
                  >
                    <NavLink
                      to="/sankya-Shastram"
                      className="dropdown-item"
                      activeClassName="active"
                    >
                      సంఖ్య శాస్త్రం
                    </NavLink>
                    <NavLink
                      to="/grahalu"
                      className="dropdown-item"
                      activeClassName="active"
                    >
                      గ్రహాలు
                    </NavLink>
                    <NavLink
                      to="/bhavishyavani"
                      className="dropdown-item"
                      activeClassName="active"
                    >
                      భవిష్యవాణి
                    </NavLink>
                    <NavLink
                      to="/vasthu-chitkalu"
                      className="dropdown-item"
                      activeClassName="active"
                    >
                      వాస్తు చిట్కాలు
                    </NavLink>
                  </div>
                </li>
                {/* <li className="nav-item dropdown">
                                    <a
                                        className="nav-link dropdown-toggle"
                                        href="#"
                                        id="navbarDropdownMenuLink8"
                                        role="button"
                                        onClick={toggleNav}
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                        activeClassName="active"
                                    >
                                        శకున శాస్త్రం
                                    </a>
                                    <div className="dropdown-menu" aria-labelledby="navbarDropdownMenuLink8">
                                        < NavLink to="/Balli-Shastram" className="dropdown-item" activeClassName="active">బల్లి శాస్త్రం</NavLink>
                                        {/* < Link to="/pillishastram" className="dropdown-item" >పిల్లి శాస్త్రం</Link> */}
                {/* </div>
                                </li> */}
                <li className="nav-item dropdown">
                <NavLink
  className={`nav-link dropdown-toggle ${isValuableInfoActive ? 'active' : ''}`}
  href="#"
  id="navbarDropdownMenuLink9"
  role="button"
  onClick={toggleNav}
  aria-haspopup="true"
  aria-expanded="false"
  style={{
    color: isValuableInfoActive ? 'white' : 'black', // Active state text color (white) / Default (black)
  }}
>
  విలువైన సమాచారం
</NavLink>

                  <div
                    className="dropdown-menu"
                    aria-labelledby="navbarDropdownMenuLink9"
                  >
                    <NavLink
                      to="/villuvina-samacharam"
                      className="dropdown-item"
                      activeClassName="active"
                    >
                      విలువైన సమాచారం
                    </NavLink>
                    <NavLink
                      to="/nithya-sathyalu"
                      className="dropdown-item"
                      activeClassName="active"
                    >
                      నిత్య సత్యాలు
                    </NavLink>
                    <NavLink
                      to="/nithi-padhyalu"
                      className="dropdown-item"
                      activeClassName="active"
                    >
                      నీతి పద్యాలు
                    </NavLink>
                    <NavLink
                      to="/samethalu"
                      className="dropdown-item"
                      activeClassName="active"
                    >
                      సామెతలు
                    </NavLink>
                    <NavLink
                      to="/samskrutham"
                      className="dropdown-item"
                      activeClassName="active"
                    >
                      సంస్కృతం
                    </NavLink>
                    <NavLink
                      to="/rastrala-bashalu"
                      className="dropdown-item"
                      activeClassName="active"
                    >
                      రాష్ట్రాల భాషలు
                    </NavLink>
                    <NavLink
                      to="/grahanam"
                      className="dropdown-item"
                      activeClassName="active"
                    >
                      గ్రహణం
                    </NavLink>
                  </div>
                </li>
                <li className="nav-item dropdown">
                <NavLink
  className={`nav-link dropdown-toggle ${isOtherLinksActive ? 'active' : ''}`}
  href="#"
  id="navbarDropdownMenuLink10"
  role="button"
  onClick={toggleNav}
  aria-haspopup="true"
  aria-expanded="false"
  style={{
    color: isOtherLinksActive ? 'white' : 'black', // Active state text color (white) / Default (black)
  }}
>
  ఇతరములు
</NavLink>

                  <div
                    className="dropdown-menu"
                    aria-labelledby="navbarDropdownMenuLink10"
                  >
                    <NavLink
                      to="/telugu-samskrutham"
                      className="dropdown-item"
                      activeClassName="active"
                    >
                      తెలుగు సంస్కృతం
                    </NavLink>
                    <NavLink
                      to="/telugu-panchangam"
                      className="dropdown-item"
                      activeClassName="active"
                    >
                      పంచాంగం
                    </NavLink>
                    <NavLink
                      to="/sankya-pradanyata"
                      className="dropdown-item"
                      activeClassName="active"
                    >
                      సంఖ్య ప్రాధాన్యత
                    </NavLink>
                    <NavLink
                      to="/namakaranam"
                      className="dropdown-item"
                      activeClassName="active"
                    >
                      నామకరణం
                    </NavLink>
                    <NavLink
                      to="/balli-shastram"
                      className="dropdown-item"
                      activeClassName="active"
                    >
                      బల్లి శాస్త్రం
                    </NavLink>
                  </div>
                </li>
                <li className="nav-item ">
                  <NavLink
                    className="nav-link custom-link"
                    to="/ramayanam"
                    activeClassName="active"
                  >
                    రామాయణం
                  </NavLink>
                </li>
                <li className="nav-item dropdown">
                <NavLink
  className={`nav-link dropdown-toggle ${isMahabharatLinksActive ? 'active' : ''}`}
  href="#"
  id="navbarDropdownMenuLink10"
  role="button"
  onClick={toggleNav}
  aria-haspopup="true"
  aria-expanded="false"
  style={{
    color: isMahabharatLinksActive ? 'white' : 'black', // Active state text color (white) / Default (black)
  }}
>
  మహాభారతం
</NavLink>

                  <div
                    className="dropdown-menu"
                    aria-labelledby="navbarDropdownMenuLink10"
                  >
                    <NavLink
                      to="/adhi-parvam"
                      className="dropdown-item"
                      activeClassName="active"
                    >
                      ఆది పర్వము
                    </NavLink>
                    <NavLink
                      to="/sabha-parvam"
                      className="dropdown-item"
                      activeClassName="active"
                    >
                      సభా పర్వము
                    </NavLink>
                    <NavLink
                      to="/vana-parvam"
                      className="dropdown-item"
                      activeClassName="active"
                    >
                      వన పర్వము
                    </NavLink>
                    <NavLink
                      to="/virata-parvam"
                      className="dropdown-item"
                      activeClassName="active"
                    >
                      విరాట పర్వము
                    </NavLink>
                    <NavLink
                      to="/vudhyoga-parvam"
                      className="dropdown-item"
                      activeClassName="active"
                    >
                      ఉద్యోగ పర్వము
                    </NavLink>
                    <NavLink
                      to="/bhishma-parvam"
                      className="dropdown-item"
                      activeClassName="active"
                    >
                      భీష్మ పర్వము
                    </NavLink>
                    <NavLink
                      to="/dhrona-parvam"
                      className="dropdown-item"
                      activeClassName="active"
                    >
                      ద్రోణ పర్వము
                    </NavLink>
                    <NavLink
                      to="/karna-parvam"
                      className="dropdown-item"
                      activeClassName="active"
                    >
                      కర్ణ పర్వము
                    </NavLink>
                    <NavLink
                      to="/salya-parvam"
                      className="dropdown-item"
                      activeClassName="active"
                    >
                      శల్య పర్వము
                    </NavLink>
                    <NavLink
                      to="/swothika-parvam"
                      className="dropdown-item"
                      activeClassName="active"
                    >
                      సౌప్తిక పర్వము
                    </NavLink>
                    <NavLink
                      to="/sri-parvam"
                      className="dropdown-item"
                      activeClassName="active"
                    >
                      స్త్రీ పర్వము
                    </NavLink>
                    <NavLink
                      to="/santhi-parvam"
                      className="dropdown-item"
                      activeClassName="active"
                    >
                      శాంతి పర్వము
                    </NavLink>
                    <NavLink
                      to="/anusasanika-parvam"
                      className="dropdown-item"
                      activeClassName="active"
                    >
                      అనుశాసనిక పర్వము
                    </NavLink>
                    <NavLink
                      to="/aswamedha-parvam"
                      className="dropdown-item"
                      activeClassName="active"
                    >
                      అశ్వమేధ పర్వము
                    </NavLink>
                    <NavLink
                      to="/asramavasa-parvam"
                      className="dropdown-item"
                      activeClassName="active"
                    >
                      ఆశ్రమవాస పర్వము
                    </NavLink>
                    <NavLink
                      to="/mousala-parvam"
                      className="dropdown-item"
                      activeClassName="active"
                    >
                      మౌసల పర్వము
                    </NavLink>
                    <NavLink
                      to="/mahaprasthanika-parvam"
                      className="dropdown-item"
                      activeClassName="active"
                    >
                      మహాప్రస్థానిక పర్వము
                    </NavLink>
                    <NavLink
                      to="/swargarohana-parvam"
                      className="dropdown-item"
                      activeClassName="active"
                    >
                      స్వర్గారోహణ పర్వము
                    </NavLink>
                  </div>
                </li>
                <li className="nav-item dropdown">
  <NavLink
    className={`nav-link dropdown-toggle ${isBhagavadGitaActive ? 'active' : ''}`}
    href="#"
    id="navbarDropdownMenuLink10"
    role="button"
    onClick={toggleNav}
    aria-haspopup="true"
    style={{
      color: isBhagavadGitaActive ? 'white' : 'black', // Active state text color (white) / Default (black)
    }}
    aria-expanded={isNavOpen ? "true" : "false"}
  >
    భగవద్గీత
  </NavLink>
  <div className="dropdown-menu" aria-labelledby="navbarDropdownMenuLink10">
    <NavLink to="/krishnani-jananam" className="dropdown-item" activeClassName="active">
      శ్రీకృష్ణుని జీవితం
    </NavLink>
    <NavLink to="/pandugala-visistatha" className="dropdown-item" activeClassName="active">
      పండుగలు విశిష్టత
    </NavLink>
    <NavLink to="/geetha-saramsam" className="dropdown-item" activeClassName="active">
      గీతా సారాంశం
    </NavLink>
    <NavLink to="/bhagavathgita" className="dropdown-item" activeClassName="active">
      భగవద్గీత
    </NavLink>
    <NavLink to="/pandugaluu" className="dropdown-item" activeClassName="active">
      పండుగలు
    </NavLink>
    <NavLink to="/sri-krishna-astrotharalu" className="dropdown-item" activeClassName="active">
      శ్రీ కృష్ణ అష్టోత్తరము
    </NavLink>
    <NavLink to="/sri-krishnastakam" className="dropdown-item" activeClassName="active">
      శ్రీ కృష్ణాష్టకం
    </NavLink>
    <NavLink to="/bhakthi-sukthulu" className="dropdown-item" activeClassName="active">
      భగవద్గీత సుక్తులు
    </NavLink>
    <NavLink to="/vasthavalu" className="dropdown-item" activeClassName="active">
      వాస్తవాలు
    </NavLink>
  </div>
</li>

                {/* <li className="nav-item"><NavLink className="nav-link" to='/Karthikapuranam' activeClassName="active">కార్తీకపురాణం</NavLink></li>
                            <li className="nav-item"><NavLink className="nav-link" to='/Astakalu' activeClassName="active">అష్టకాలు</NavLink></li>
                            <li className="nav-item"><NavLink className="nav-link" to='/Villuvinasamacharam' activeClassName="active">ముఖ్యమైన సమాచారం</NavLink></li> */}
              </ul>
            </div>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
